const common = {
  // Header
  "header.english": "English",
  "header.francais": "Français",
  "header.searchPlaceholder": "Search…",
  "header.searchAria": "Search",
  "header.submitSearch": "Submit search",
  "header.trustees": "Trustees",
  "header.memberLogin": "Member Login",
  "header.decreaseFont": "Decrease font size",
  "header.increaseFont": "Increase font size",

  // Navbar
  "nav.home": "Home",
  "nav.aboutTheFund": "About the Fund",
  "nav.summaryPlan": "Summary Plan",
  "nav.planRules": "Plan Rules",
  "nav.resources": "Resources",
  "nav.news": "News",
  "nav.faq": "FAQ",
  "nav.member": "Member",
  "nav.contactUs": "Contact Us",
  "nav.mobileTitle": "Navigation",
  "nav.toggleAria": "Toggle navigation",

  // Navbar dropdown
  "nav.annualReports": "Annual Reports",
  "nav.newsletters": "Newsletters",
  "nav.forms": "Forms",
  "nav.whatHappensIf": "What happens if?",
  "nav.thingsYouNeedToKnow": "Things you need to know",
  "nav.miscellaneous": "Miscellaneous",
  "nav.links": "Links",
  "nav.rrspComparisons": "RRSP Comparisons",
  "nav.someppNotice": "SOMEPP Notice",
  "nav.keyPlanDefinitions": "Understanding Key Plan Definitions",

  // Footer
  "footer.tagline": "Administering pension benefits for eligible musicians and beneficiaries across Canada.",
  "footer.thePlan": "THE PLAN",
  "footer.aboutTheFund": "About the Fund",
  "footer.summaryPlan": "Summary Plan",
  "footer.planRules": "Plan Rules",
  "footer.faq": "FAQ",
  "footer.news": "News",
  "footer.contactUs": "Contact Us",
  "footer.resources": "RESOURCES",
  "footer.annualReports": "Annual Reports",
  "footer.newsletters": "Newsletters",
  "footer.forms": "Forms",
  "footer.whatHappensIf": "What Happens If?",
  "footer.keyPlanDefinitions": "Key Plan Definitions",
  "footer.contact": "CONTACT",
  "footer.address": "200 Yorkland Blvd., Suite 605\nToronto, Ontario M2J 5C1",
  "footer.tollFree": "Toll-free: 1-888-462-6666",
  "footer.fax": "Fax: 416-497-4742",
  "footer.privacyPolicy": "Privacy Policy",
  "footer.copyright": "© {{year}} Musicians' Pension Fund of Canada. All rights reserved.",

  // ScrollToTop
  "scrollToTop": "Back to top",

  // Search page shared
  "search.pageLabel": "Find Information",
  "search.title": "Search Results",
  "search.resultsFor": "Search results for:",
  "search.enterTerm": "Enter a search term to find pages, documents, news, and FAQs.",
  "search.noQueryTitle": "Enter a search term",
  "search.noQueryDesc": "Enter a search term to find pages, documents, news, and FAQs.",
  "search.noResults": "No results found",
  "search.noResultsDesc": "No results found. Try searching for a different term or browse the FAQ and Resources pages.",
  "search.browseFAQ": "Browse FAQ",
  "search.browseResources": "Browse Resources",
  "search.resultsCount": "{{count}} result",
  "search.resultsCount_plural": "{{count}} results",
  "search.found": "found",
  "search.typePage": "Page",
  "search.typeResource": "Resource",
  "search.typeFAQ": "FAQ",
  "search.typeNews": "News",

  // Resources shared
  "resources.pageLabel": "Member Resources",
  "resources.pageTitle": "Resources & Documents",
  "resources.pageDesc": "Access plan documents, forms, reports, and reference materials for the Musicians' Pension Fund of Canada.",
  "resources.categories": "Categories",
  "resources.selectCategory": "Select Resource Category",
  "resources.documentCount": "{{count}} document",
  "resources.documentCount_plural": "{{count}} documents",
  "resources.view": "View",
  "resources.open": "Open",

  // News shared
  "news.pageLabel": "Fund Updates",
  "news.pageTitle": "News & Updates",
  "news.pageDesc": "Read the latest announcements, notices, and updates from the Musicians' Pension Fund of Canada.",
  "news.archive": "Archive",
  "news.selectNews": "Select News Item",
  "news.readAnnouncement": "Read Announcement",
  "news.readNotice": "Read Notice",
  "news.readUpdate": "Read Update",
  "news.readMore": "Read More",
  "news.readResponse": "Read Response",
  "news.viewNewsletter": "View Newsletter",
  "news.readBackground": "Read Background Information",

  // FAQ shared
  "faq.pageLabel": "Help Centre",
  "faq.pageTitle": "Frequently Asked Questions",
  "faq.pageDesc": "Find answers to common questions about the Plan, benefits, contributions, life events, and member account access.",
  "faq.categories": "Categories",
  "faq.selectCategory": "Select FAQ Category",
  "faq.viewPlanSummary": "View Plan Summary",
  "faq.viewKeyDefinitions": "View Key Plan Definitions",
  "faq.emailFundOffice": "Email Fund Office",
  "faq.accessPortal": "Access Member Portal",
  "faq.viewAnnualReports": "View Annual Reports",
};

export default common;